import type {
  PointArray,
  PointSiArray,
} from '../types/contour-definition-array-type';

/**
 *
 * @param inputArray 2D  array of points [[x,y],...]
 * @returns PointArray type [{x,y}]
 */
export function convertArrayToPointArray(inputArray: number[][]): PointArray {
  return inputArray.map(([x, y]) => ({ x, y }));
}

export function convertPointArrayToArray(inputArray: PointArray): number[][] {
  return inputArray.map(({ x, y }) => [x, y]);
}

export function convertPointSiArrayToArray(
  inputArray: PointSiArray,
): number[][] {
  return inputArray.map(({ x, y }) => [x, y]);
}
